import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Button,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  useTheme
} from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import ButtonWithPermissions from '../../../../../components/buttonWithPermissions/buttonWithPermissions'
import { CardWithTransition } from '../../../../../components/shared/cardWithTransition/CardWithTransition'
import { LoadingCard } from '../../../../../components/shared/loadingCard/loadingCard'
import { ButtonOption } from '../../../../../components/shared/splitButton/splitButton'
import { DatePeriod } from '../../../../../model'

import { EmptyContent } from '../shared/emptyCard'
import { Header } from '../shared/header'

import moment from 'moment'
import { ComunicationExternalsTable } from '../../../../../components/shared/comunicationExternalsTable/comunicationExternalsTable'
import useExternals from '../../../../../components/shared/comunicationExternalsTable/comunicationExternalsTable.hooks'
import { styles } from './externalsCard.styles'
import { ExternalsCardProps } from './externalsCard.types'
import { useSelector } from 'react-redux'
import { selectClientData } from '../../../../../redux/selectors/client.selectors'
import { Form, UserPermission } from '@globaleris/ui.library'
import { CreateComunicationDialog } from './components/createComunicationDialog'
import { hasPermission } from '../../../../../helpers/permissionsHelper'
import { Resources } from '../../../../../model/RBAC/constants'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

const dateRange: DatePeriod = {
  start: moment('2023-01-01').toDate(),
  end: moment('2023-01-20').toDate()
}

export const ExternalsCard: React.FC<ExternalsCardProps> = ({ clientID, error, onRetry }) => {
  const [t] = useTranslation(['globalerisLibrary', 'clientFile', 'enums'])
  const history = useHistory()

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false)

  const {
    externals,
    mailingList,
    isFetchingExternals,
    isFetchingMailingList,
    refreshExternals,
    setIdMailingList
  } = useExternals({ clientID })

  const ExternalsHeader = () =>
    React.useMemo(() => {
      return (
        <Header
          avatarIcon={<FontAwesomeIcon size={'lg'} icon={faEnvelope as IconProp} />}
          title={t('clientFile:components.externalsCard.title')}
          titleVariant="secondary"
        />
      )
    }, [t])

  if (error) {
    return (
      <CardWithTransition show={true} raised>
        <ExternalsHeader />
        <EmptyContent title={t('clientFile:components.externalsCard.errorCard.errorMessage')}>
          <ButtonWithPermissions
            hasPermission={true}
            size="small"
            color="primary"
            variant="contained"
            onClick={refreshExternals}
          >
            {t('clientFile:components.externalsCard.errorCard.buttonLabel')}
          </ButtonWithPermissions>
        </EmptyContent>
      </CardWithTransition>
    )
  }

  const handleClickAdd = (option: ButtonOption) => {
    // onClickAdd(option)
  }

  if (isFetchingExternals) {
    return <LoadingCard />
  }

  return (
    <>
      <CardWithTransition show={true} raised>
        <ExternalsHeader />
        {!error && externals && externals.length > 0 ? (
          <>
            <CardContent className={classes.cardContent}>
              <ComunicationExternalsTable
                externals={externals}
                mailingList={mailingList}
                isFetchingMailingList={isFetchingMailingList}
                onSelectMailingList={setIdMailingList}
                onRefreshExternals={refreshExternals}
                onNotificationChange={p => {}}
                cardMode
              />
            </CardContent>
            <CardActions className={classes.cardActionsRight}>
              <ButtonWithPermissions
                size="small"
                color="primary"
                hasPermission={hasPermission(Resources.ComunicationsCenterExternals, [
                  UserPermission.EDIT
                ])}
                onClick={() => setOpenCreateDialog(true)}
              >
                {t('clientFile:components.externalsCard.actions.create')}
              </ButtonWithPermissions>
            </CardActions>
          </>
        ) : (
          <EmptyContent title={t('clientFile:components.externalsCard.emptyCard.title')}>
            <ButtonWithPermissions
              size="small"
              color="primary"
              variant="contained"
              hasPermission={hasPermission(Resources.ComunicationsCenterExternals, [
                UserPermission.EDIT
              ])}
              onClick={() => setOpenCreateDialog(true)}
            >
              {t('clientFile:components.externalsCard.actions.create')}
            </ButtonWithPermissions>
          </EmptyContent>
        )}
      </CardWithTransition>
      <CreateComunicationDialog
        open={openCreateDialog}
        setOpen={setOpenCreateDialog}
        onSuccess={refreshExternals}
      />
    </>
  )
}
